import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Skeleton, Table, TableBody, TableCell, TableRow, Tooltip, Typography } from '@mui/material'

const Item = ({
  title,
  number = 0,
  lengthLcs = 0,
  color = '',
  loading,
  isSelected,
  onFilter,
  keyName,
  bgColor,
  opacity
}) => {
  return (
    <Box
      className={[
        'flex items-center gap-2 w-full py-1',
        onFilter ? 'bg-clickeabled2 cursor-pointer' : ''
      ].join(' ')}
      onClick={onFilter}
      style={{
        backgroundColor: bgColor,
        opacity
      }}
    >
      <div className='flex items-center gap-1 px-2'>
        <FontAwesomeIcon icon='square' className='text-lg' style={{ color }} />
        <Typography
          component='div'
          className='text-sm font-bold min-w-100px'
          style={{
            color,
            width: '100px'
          }}
        >
          {title}
        </Typography>
      </div>

      {loading ? (
        <Skeleton variant='rounded' className='w-full h-8' />
      ) : (
        <Box className='w-full h-8 rounded pr-4'>
          <Tooltip
            title={
              loading ? (
                'Loading...'
              ) : (
                <div>
                  <span className='font-bold pr-2'>{title}:</span>
                  <span>
                    {number} {keyName}
                  </span>
                </div>
              )
            }
            placement='top'
            arrow
          >
            <Box
              className='w-full h-8 rounded flex items-center justify-start'
              style={{
                backgroundColor: 'rgba(0,0,0,0.03)'
              }}
            >
              <Box
                className='rounded h-8 flex items-center justify-start '
                style={{
                  width: `${(number * 100) / lengthLcs}%`,
                  backgroundColor: color || 'rgba(0,0,0,0.1)'
                }}
              />

              <Typography
                component='div'
                className='text-sm font-bold px-2 text-nowrap'
                style={{ width: 50 }}
              >
                {number}
              </Typography>
            </Box>
          </Tooltip>
        </Box>
      )}
    </Box>
  )
}

const LGDistribution = ({ loading, lcs, lgType = [], onFilter, keyName }) => {
  return (
    <Box>
      <Box className='flex items-center justify-between '>
        <Typography component='div' color='primary' className='text-xl font-bold' sx={{ flexGrow: 1 }}>
          See how much progress you have made?
        </Typography>
        <Typography component='div' className='text-sm text-primary'>
          {loading ? (
            <Skeleton variant='text' width={100} />
          ) : (
            <span className='text-muted-foreground pr-4'>
              {lcs.length} {keyName}
            </span>
          )}
        </Typography>
      </Box>
      <Box className='flex flex-col gap-2'>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell style={{ padding: 0 }}>
                <Box className={['flex items-center gap-4 w-full '].join(' ')}>
                  <Typography
                    component='div'
                    className='text-sm font-bold px-2 min-w-100px opacity-75'
                    style={{ width: '100px' }}
                  >
                    Growth Type
                  </Typography>
                  <Typography component='div' className='text-sm font-bold opacity-75'>
                    Number of {keyName}
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ padding: 0 }}>
                <Item
                  title='Growing'
                  number={lcs.filter((lc) => lc.lgType === 'growing').length}
                  lengthLcs={lcs.length}
                  loading={loading}
                  isSelected={lgType.includes('growing')}
                  onFilter={() => onFilter('growing')}
                  color={lgType.length > 0 && !lgType.includes('growing') ? '#ccc' : '#1270aa'}
                  bgColor={lgType.length > 0 && !lgType.includes('growing') ? '#fff' : 'transparent'}
                  opacity={lgType.length > 0 && !lgType.includes('growing') ? 0.5 : 1}
                  keyName={keyName}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ padding: 0 }}>
                <Item
                  title='Steady'
                  number={lcs.filter((lc) => lc.lgType === 'steady').length}
                  lengthLcs={lcs.length}
                  loading={loading}
                  isSelected={lgType.includes('steady')}
                  onFilter={() => onFilter('steady')}
                  color={lgType.length > 0 && !lgType.includes('steady') ? '#ccc' : '#fc7d0b'}
                  bgColor={lgType.length > 0 && !lgType.includes('steady') ? '#fff' : 'transparent'}
                  opacity={lgType.length > 0 && !lgType.includes('steady') ? 0.5 : 1}
                  keyName={keyName}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ padding: 0 }}>
                <Item
                  title='Needs review'
                  number={lcs.filter((lc) => lc.lgType === 'needs-review').length}
                  lengthLcs={lcs.length}
                  loading={loading}
                  isSelected={lgType.includes('needs-review')}
                  onFilter={() => onFilter('needs-review')}
                  color={lgType.length > 0 && !lgType.includes('needs-review') ? '#ccc' : '#c85201'}
                  bgColor={lgType.length > 0 && !lgType.includes('needs-review') ? '#fff' : 'transparent'}
                  opacity={lgType.length > 0 && !lgType.includes('needs-review') ? 0.5 : 1}
                  keyName={keyName}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ padding: 0 }}>
                <Item
                  title='Not yet assessed'
                  number={lcs.filter((lc) => lc.lgType === 'not-yet-assessed').length}
                  lengthLcs={lcs.length}
                  loading={loading}
                  isSelected={lgType.includes('not-yet-assessed')}
                  onFilter={() => onFilter('not-yet-assessed')}
                  color={lgType.length > 0 && !lgType.includes('not-yet-assessed') ? '#ccc' : '#000'}
                  bgColor={lgType.length > 0 && !lgType.includes('not-yet-assessed') ? '#fff' : 'transparent'}
                  opacity={lgType.length > 0 && !lgType.includes('not-yet-assessed') ? 0.5 : 1}
                  keyName={keyName}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </Box>
  )
}

export default LGDistribution
